export default () => {
  const items = document.querySelectorAll('.sort-bar__item');
  let selectItem = [];
  let btnGroupItem = [];
  let sorterType = '';

  // Check if there is sort-bar__item
  if (items.length > 0) {
    startSorter(items);
  }

  /**
   * Start the sorters
   * @param {NodeList} el Elements that are going to be checked
   * @returns {NodeList} Returns the active sorter
   */
  function startSorter(el) {
    // Loop through sort-bar__item
    for (let i = 0; i < el.length; i++) {
      // Loop through sort-bar__item children
      for (let j = 0; j < el[i].children.length; j++) {
        if (el[i].children[j].matches('select')) {
          sorterType = 'select';
          selectItem =  document.getElementById(el[i].children[j].id);
          addSortListener(selectItem);
        } else if (el[i].children[j].matches('.btn-group')) {
          sorterType = 'btn-group';
          btnGroupItem = document.querySelectorAll('.btn-group input[type="radio"]');
          addSortListener(btnGroupItem);
        }
      }
    }
  }

  /**
   * Add event listener based on the element
   * @param {NodeList|Object} el The element to listen to
   */
  function addSortListener(el) {
    let startListener = true;
    // Select
    if(sorterType === 'select') {
      // Check if every option has a value
      for(let i = 0; i < el.children.length; i++) {
        if(!el.children[i].value) {
          startListener = false;
        }
      }

      if(startListener) {
        el.addEventListener('change', () => {
          sortItems(el.value);
          // updateSorter('btn-group', el.value);
        });
      } else {
        throwError('no-value-select');
      }
    }
    // Button group
    else if(sorterType === 'btn-group') {
      // Check if every radio has a value
      for (let i = 0; i < el.length; i++) {
        if (!el[i].value) {
          startListener = false;
        }
      }

      if(startListener) {
        for(let i = 0; i < el.length; i++) {
          el[i].addEventListener('change', () => {
            let radioValue = '';
            for(let i = 0; i < el.length; i++) {
              if(el[i].checked) {
                radioValue = el[i].value;
              }
            }
            sortItems(radioValue);
            // updateSorter('select', radioValue);
          });
        }
      } else {
        throwError('no-value-radio');
      }
    } else {
      throwError('bad-element');
    }
  }

  /**
   * Show/hide items based on the sorter value
   * @param {string} val The sorter's value
   */
  function sortItems(val) {
    const items = document.querySelectorAll('.list-card__item');
    let showItem = 0;
    let startSort = true;

    // Check if all elements have a data-sort attribute
    for(let i = 0; i < items.length; i++) {
      if(!items[i].dataset.sort) {
        startSort = false;
      }
    }

    if(startSort) {
      // Check if there is multiple values to test
      for (let i = 0; i < items.length; i++) {
        if (items[i].dataset.sort.length > 1) {
          let values = items[i].dataset.sort.split(' ');
          for (let i = 0; i < values.length; i++) {
            if (values[i] === val) {
              showItem += 1;
            }
          }
        }
        if (val === 'all' || items[i].dataset.sort === val || showItem > 0) {
          if (items[i].classList.contains('js-is--hidden')) {
            items[i].classList.remove('js-is--hidden');
          }
          showItem = 0;
        } else if (items[i].dataset.sort !== val || showItem === 0) {
          items[i].classList.add('js-is--hidden');
        }
      }
    } else {
      throwError('no-data-sort');
    }
  }

  /**
   * Update elements
   * @param {string} el The element to update
   * @param {string} val The value choosed by the user
   */
  // function updateSorter(el, val) {
  //   if(el === 'select') {
  //     // Waiting for the update method to be add to the dropdown component
  //     // for(let i = 0; i < selectItem.options.length; i++) {
  //     //   if(selectItem.options[i].value === val) {
  //     //     selectItem.selectedIndex = i;
  //     //   }
  //     // }
  //   }
  //   if(el === 'btn-group') {

  //   }
  // }

  /**
   * Show errors in the console
   * @param {string} error The type of error
   */
  function throwError(error) {
    switch (error) {
      case 'bad-element':
        console.error('Bad sorter element: you should use a button group (.btn-group) with radio buttons or a dropdown');
        break;
      case 'no-data-sort':
        console.error('No [data-sort] attribute found: you should add [data-sort] attributes to every .card-list__item');
        break;
      case 'no-value-select':
        console.error('Select option value is not initialized: you should provide a value for each option in the select');
        break;
      case 'no-value-radio':
        console.error('Radio input option has no value attribute: you should provide a value for each radio input');
        break;
    }
  }
}
